import styled, { createGlobalStyle } from 'styled-components';

export const ListingPageAppGlobals = createGlobalStyle`
  // Workaround to fix the selectbox icon in the sort by select
  .dc-icon {
    box-sizing: content-box !important;
  }


  body {
    a {
      color: #4855A0;

      &:hover {
        color: #4855A0;
      }
    }
  }

  [data-component='Footer'] {
    padding: 0 10px;

    @media only screen and (min-width: 1025px) {
      padding: 0;
    }
  }

  [data-component='Header'] {
    z-index: 10;
  }

  [data-component='Menu'] {
    margin-bottom: 0;
  }

  [data-element='SectionLinks'] > [data-element='CommonLinks'] [data-element='Item'] {
    width: 33.333%;
    @media only screen and (min-width: 768px) {
      width: auto;
    }
  }

  [data-component='Logo'] [data-element='Desktop'] {
    height: 60px;
  }
`;

export const ListingPageAppWrapper = styled.div`
  font: 14px / 1.231 Helvetica, Arial, sans-serif;
  color: #222;

  * {
    box-sizing: border-box;
  }

  // This removes unnecessary bottom margin on desktop header menu items
  // TODO: remove this as soon as the whole application is migrated to style-components
  &
    div[class|='DesktopNavigation__NavigationListWrapper']
    ul[class|='DesktopNavigation__NavigationList']
    > li {
    margin-bottom: 0;
  }

  @media only screen and (min-width: 1025px) {
    .resultGrid {
      font: 13px / 1.231 Helvetica, Arial, sans-serif;
    }
  }
`;
